export const mobileMaxWidth = 400;
